import { createStore, combineReducers, applyMiddleware, compose } from 'redux'

import accountReducer from '../redux-store/actions/account';
import storeReducer from '../redux-store/actions/store';
import selectedReducer from '../redux-store/actions/selected';
import printerReducer from '../redux-store/actions/printer';
import footerReducer from '../redux-store/actions/footer';

const initialState = {
  sidebarShow: true,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const rootReducer = combineReducers({
  account: accountReducer,
  selected: selectedReducer,
  store: storeReducer,
  state: changeState,
  printer: printerReducer,
  footer: footerReducer
})

const store = createStore(rootReducer)
export default store
